import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { dateSchema, parseToDateValue } from "@/features/FormCard/utils";
import { z } from "zod";

// Enum options from policies.rb
export const appOptions = [
  { value: "admin_panel", label: "Admin Panel" },
  { value: "user_portal", label: "User Portal" },
  { value: "analytics", label: "Analytics" },
];

export const policyMethodOptions = [
  { value: "create", label: "Create" },
  { value: "read", label: "Read" },
  { value: "update", label: "Update" },
  { value: "delete", label: "Delete" },
];

// Zod schema
export const filterPoliciesSchema = z.object({
  policeable_type_contains: z.string().nullable().optional(),
  policeable_id: z
    .preprocess((val) => {
      if (val === "" || val == null) return undefined;
      return Number(val);
    }, z.number())
    .optional(),
  path_contains: z.string().nullable().optional(),
  app_contains: z.string().nullable().optional(),
  policy_method_contains: z.string().nullable().optional(),
  created_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  created_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  updated_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  updated_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});

// TypeScript type
export type FilterPoliciesSchema = z.infer<typeof filterPoliciesSchema>;

// Filter fields configuration
export const fields: Field[] = [
  {
    name: "policeable_type_contains",
    label: "Policeable Type",
    type: "input",
  },
  {
    name: "policeable_id",
    label: "Policeable ID",
    type: "input",
    input_type: "number",
  },
  {
    name: "path_contains",
    label: "Path",
    type: "input",
  },
  {
    name: "app_contains",
    label: "App",
    type: "select",
    useTranslation: false,
    options: appOptions,
  },
  {
    name: "policy_method_contains",
    label: "Policy Method",
    type: "select",
    useTranslation: false,
    options: policyMethodOptions,
  },
  {
    name: "created_at_from",
    label: "Created From",
    type: "date",
  },
  {
    name: "created_at_to",
    label: "Created To",
    type: "date",
  },
  {
    name: "updated_at_from",
    label: "Updated From",
    type: "date",
  },
  {
    name: "updated_at_to",
    label: "Updated To",
    type: "date",
  },
];

export const client = "legacy-quantilia";

export function FilterPolicies() {
  return (
    <FilterTable
      client={client}
      schema={filterPoliciesSchema}
      tableName="policies"
      customBuildPath={() => `${client}/policy`}
      fields={fields}
      columns={2}
    />
  );
}
